import { Box, type BoxProps } from '../Box'
import {
  apiVariantCss,
  freeVariantCss,
  proVariantCss,
  tagLabelCss,
  trialVariantCss,
  smallVariantCss,
  mediumVariantCss,
} from './TierBadge.css'

enum Tier {
  Free = 'free',
  Pro = 'pro',
  Trial = 'trial',
  API = 'api',
  Legacy = 'legacy',
}

type TierBadgeProps = Omit<BoxProps, 'children' | 'size' | 'opacity'> & {
  tier?: `${Tier}`
  children: string
  size: 's' | 'm'
  opacity: 0 | 1
  // onClick?: undefined // hint that Labels like this are not clickable
}

/** @deprecated */
export const TierBadge = ({
  tier,
  children,
  size,
  opacity,
  ...props
}: TierBadgeProps) => (
  <Box
    as="span"
    opacity={opacity}
    className={[
      tagLabelCss,
      {
        [smallVariantCss]: size === 's',
        [mediumVariantCss]: size === 'm',
        [freeVariantCss]: tier === 'free',
        [proVariantCss]: tier === 'pro',
        [apiVariantCss]: tier === 'api',
        [trialVariantCss]: tier === 'trial',
      },
    ]}
    {...props}
  >
    {children}
  </Box>
)

TierBadge.displayName = 'TagLabel'
